import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
          常见答疑
        </h2>
        <div className="max-w-3xl mx-auto flex flex-col gap-4">
          {faqItems.map((item, i) => (
            <details key={i} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer">
              <summary className="flex items-center justify-between px-5 py-4 text-foreground-900 font-medium text-sm md:text-base list-none">
                <span>{item.q}</span>
                <i className="ri-add-line text-lg text-foreground-400 group-open:hidden" />
                <i className="ri-subtract-line text-lg text-primary-500 hidden group-open:block" />
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}